export default __webpack_public_path__ + "images/9ef0b9bb85299a9273136a7dd04e8471-emoji-worried.svg";